import React from 'react';
import { connectHits } from 'react-instantsearch-dom';
import { Link, useStaticQuery, graphql } from 'gatsby';
import Col from '../../primitives/grid/col';
import Row from '../../primitives/grid/row';
import RowSet from '../../primitives/grid/row-set';
import PersonContactIcon from '../../../images/person-contact-icon.svg';
import PersonDetailsIcon from '../../../images/person-details-icon.svg';
import PersonLocationIcon from '../../../images/person-location-icon.svg';
import { WPImage } from '../../primitives/image/gatsby-image-svg-fallback';
import AvatarModal from '../../primitives/avatar-modal';
import NoResults from '../../search/no-results';
import PersonIcon from '../../../images/user-solid.svg';
import getAlgoliaImageFromArray from '../../../utils/get-algolia-image-from-array';
import StyledLink from '../../primitives/styled-link';

const PersonsFilterCard = ({
    title,
    link,
    job,
    description,
    image,
    contact,
    singlePage,
    einrichtung,
    focus,
    hasSinglePage,
}) => {
    const urllink = new URL(link);
    const foundImage = getAlgoliaImageFromArray(image);
    const filteredEinrichtung = einrichtung?.filter((item) => {
        return item?.types?.nodes?.length > 0 && item.types.nodes[0]?.slug !== 'treatment' && item.types.nodes[0]?.slug !== 'topic';
        return true;
    });
    return (
        <div
            css={{
                width: '100%',
                height: 'auto',
                display: 'flex',
                position: 'relative',
                alignItems: 'flex-start',
                flexDirection: 'column',
                marginTop: '0!important',
                paddingTop: '47px',
                paddingBottom: '20px',
                '@media (max-width: 767px)': {
                    paddingTop: '26px',
                },
            }}
        >
            <AvatarModal
                name={title}
                job={job}
                jobDescription={description}
                contact={contact}
                einrichtung={einrichtung}
                focus={focus}
                link={
                    singlePage && urllink?.pathname ? urllink?.pathname : undefined
                }
                css={{ width: '100%', display: 'flex' }}
            >
                <Row>
                    <Col breakpoints={{
                        dt: { span: 2, rightGap: 'full' },
                        mb: { span: 1, rightGap: 'full' },
                    }}
                    >
                        {!foundImage ? (
                            <div
                                css={{
                                    width: '100%',
                                    backgroundColor: 'var(--color-gray-mittelgrau)',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    aspectRatio: '1 / 1',
                                }}
                            >
                                <PersonIcon
                                    css={{
                                        width: '35%',
                                        height: 'auto',
                                    }}
                                />
                            </div>
                        ) : (
                            <div
                                css={{
                                    width: '100%',
                                    backgroundColor: 'var(--color-gray-mittelgrau)',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    aspectRatio: '1 / 1',
                                }}
                            >
                                <WPImage
                                    alt="image"
                                    src={foundImage}
                                    css={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                    }}
                                />
                            </div>
                        )}
                    </Col>
                    <Col
                        breakpoints={{
                            dt: { span: 8, rightGap: 'none' },
                            tb: { span: 7, rightGap: 'none' },
                            mb: { span: 3, rightGap: 'none' },
                        }}
                        css={{
                            width: '100%',
                            height: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'left',
                        // '@media (max-width: 767px)': {
                        //     gridColumn: 'span 3',
                        // },
                        }}
                    >
                        <h3
                            className="h4"
                            css={{
                                paddingBottom: '6px',
                                textAlign: 'left',
                            }}
                        >
                            {title}
                        </h3>
                        <p
                            className="p1"
                            css={{
                                maxWidth: '628px',
                                paddingBottom: '8px',
                                textAlign: 'left',
                            }}
                            dangerouslySetInnerHTML={{ __html: job }}
                        />
                        {filteredEinrichtung
            && filteredEinrichtung?.slice(0, 3).map((item, index) => (
                <Link
                    key={index}
                    css={{
                        width: '100%',
                        height: 'auto',
                        display: 'flex',
                        alignItems: 'start',
                        paddingBottom: '8px',
                    }}
                    to={item?.uri}
                >
                    <PersonLocationIcon
                        css={{
                            width: '24px',
                            height: '24px',
                            marginRight: '7px',
                            flexShrink: 0,
                            marginTop: '3px',
                            '@media (max-width: 767px)': {
                                width: '18px',
                                height: '18px',
                            },
                        }}
                    />

                    <p
                        className="p1"
                        css={{
                            fontWeight: '600 !important',
                            textAlign: 'left',
                        }}
                        dangerouslySetInnerHTML={{ __html: item?.title }}
                    />
                </Link>
            ))}
                        {
                            filteredEinrichtung?.length > 3 && (
                                <p
                                    css={{
                                        fontSize: '20px',
                                        lineHeight: '27px',
                                        fontWeight: '600',
                                        marginLeft: '31px',
                                        '@media (max-width: 767px)': {
                                            fontSize: '14px',
                                            lineHeight: '19px',
                                            marginLeft: '25px',
                                            paddingBottom: '8px',
                                        },
                                    }}
                                >
                                    ...und
                                    {' '}
                                    {filteredEinrichtung.length - 3}
                                    {' '}
                                    mehr.
                                </p>
                            )
                        }
                    </Col>
                    <Col
                        breakpoints={{ dt: { span: 2, rightGap: 'none' } }}
                        css={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            // gridColumn: 'span 2',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            '@media (max-width: 767px)': {
                                display: 'none',
                            },
                        }}
                    >
                        <div
                            css={{
                                width: '100%',
                                height: 'auto',
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: '8px',
                                '@media (max-width: 767px)': {
                                    display: 'none',
                                },
                            }}
                        >
                            <PersonContactIcon
                                css={{
                                    width: '24px',
                                    height: '24px',
                                    objectFit: 'cover',
                                    marginRight: '7px',
                                    flexShrink: 0,
                                }}
                            />

                            <StyledLink
                                className="p1"
                                css={{
                                    fontWeight: '600 !important',
                                }}
                            >
                                Kontakt
                            </StyledLink>
                        </div>
                        { hasSinglePage && (
                            <Link
                                css={{
                                    width: '100%',
                                    height: 'auto',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                                to={urllink?.pathname}
                            >
                                <PersonDetailsIcon
                                    css={{
                                        width: '24px',
                                        height: '24px',
                                        objectFit: 'cover',
                                        marginRight: '7px',
                                        flexShrink: 0,
                                    }}
                                />

                                <p
                                    className="p1"
                                    css={{
                                        fontWeight: '600 !important',
                                    }}
                                >
                                    Details
                                </p>
                            </Link>
                        )}
                    </Col>
                </Row>
            </AvatarModal>
        </div>

    );
};
export default PersonsFilterCard;

export const Persons = connectHits(({ hits }: any) => {
    const data = useStaticQuery(graphql`
    {
      allWpEinrichtung {
        nodes {
          uri
          databaseId
          title
          acfFields {
            fieldGroupName
            subtitle
            address
          }
          slug
          types {
            nodes {
              name
              slug
            }
          }
        }
      }
    }
  `);

    const supplementalData = data?.allWpEinrichtung?.nodes || [];

    return (
        <RowSet breakpoints={{ dt: { between: 36 } }}>
            {hits && hits.length > 0 ? (
                hits.map((hit: any) => {
                    const existingEinrichtung = hit?.einrichtung; // an array
                    const reparsedEinrichtung = (() => {
                        if (Array.isArray(existingEinrichtung)) {
                            return existingEinrichtung.map(({ ID, ...props }) => {
                                const foundSupplementalData = supplementalData.find(
                                    x => x.databaseId === ID,
                                );
                                if (foundSupplementalData) {
                                    return foundSupplementalData;
                                }
                                return null;
                            }).filter(x => !!x);
                        }
                        return [];
                    })();
                    const newDoctorEinrichtung = {
                        einrichtung: reparsedEinrichtung,
                    };
                    return (
                        <PersonsFilterCard
                            title={hit?.post_title}
                            link={hit?.permalink}
                            job={hit?.job}
                            description={hit?.job_description}
                            image={hit?.images}
                            contact={hit?.contact}
                            singlePage={hit?.single_page}
                            einrichtung={newDoctorEinrichtung?.einrichtung}
                            focus={hit?.focus}
                            hasSinglePage={hit?.single_page}
                        />
                    );
                })
            ) : (
                <NoResults />
            )}
        </RowSet>
    );
});
